/* launch.icon.svg.js */

module.exports = {
    icon: `
            <svg  class="center-vertically" viewBox="-227 229 24 24" preserveAspectRatio="none">
                <path class="foreground-gl" d="M-212.3,229v2.7h4.8l-13.1,13.1l1.9,1.9l13.1-13.1v4.8h2.7V229 M-205.7,250.3h-18.7v-18.7h9.3V229h-9.3
	                c-1.5,0-2.7,1.2-2.7,2.7v18.7c0,1.5,1.2,2.7,2.7,2.7h18.7c1.5,0,2.7-1.2,2.7-2.7V241h-2.7V250.3z"/>
            </svg>
         `
};
